module.exports = __webpack_public_path__ + "img/ps.42f2391e.svg";